// extracted by mini-css-extract-plugin
module.exports = {"pt-hospital-table":"pt-hospital-table-1d12df4f485ab19d45e8079e06f30f7c","download-qrcode":"download-qrcode-88fd4a2bce54e334695d12c03ba3307d"};